import React from "react";
import PublicOralExamEmbedPage from "./PublicOralExamEmbedPage";

export default function InterviewPracticePage() {
  return <PublicOralExamEmbedPage practiceType="interview_practice" />;
}
